module.exports = __webpack_public_path__ + "static/media/settingNormal.f062539b.svg";